// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUnorderedListOutlinedSvg from "@fishx/icons-svg/es/asn/PUnorderedListOutlined";
import FishxIcon from '../components/FishxIcon';

var PUnorderedListOutlined = function PUnorderedListOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUnorderedListOutlinedSvg
  }));
};

PUnorderedListOutlined.displayName = 'PUnorderedListOutlined';
export default React.forwardRef(PUnorderedListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUnorderedListOutlined.js
// module id = 3708
// module chunks = 0